import clsx from 'clsx';
import useMathRender from 'core/hooks/useMathRender';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';

const TextRich = ({ className, id, lang, text, title }) => {
  const rootNode = useRef(null);
  useMathRender(rootNode, [text]);

  return <div ref={rootNode} id={id} lang={lang} dangerouslySetInnerHTML={{ __html: text }} className={clsx('text-html', className)} title={title} />;
};

TextRich.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  lang: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
};

TextRich.defaultProps = {
  id: 'useMathRender',
  text: '',
};

export default TextRich;
